/* globals document */
const $ = require('jquery');

class Hamburger {
  init() {
    $('.hamburger').click(e => {
      e.stopPropagation();
      e.preventDefault();
      const targetElement = document.getElementById(e.currentTarget.dataset.id);
      $(e.currentTarget).toggleClass('is-active');
      $(targetElement).toggleClass('expanded');
      $('body').toggleClass('menu-expanded');
    });
  }
}

export default (() => new Hamburger())();
